import { IDefineCommand, IQuery } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { PathTopic } from '../builders/path_topic_builder';

angular
  .module('data-ng-todos')
  .factory(
    'topicToggleOptedInCommand',
    function topicToggleOptedInCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngPathCurrentTopicDatastore: IDatasource<PathTopic>,
      log: any
    ) {
      return defineCommand(
        'topicToggleOptedInCommand',
        function topicToggleOptedInCommand(deferred: ng.IDeferred<IQuery[]>, topic: PathTopic) {
          $http
            .put('/item/studenttopic/topic_id/' + topic.id, {
              has_opted_in: topic.has_opted_in
            })
            .then((response: any) => {
              ngPathCurrentTopicDatastore.put({
                id: topic.id,
                has_opted_in: topic.has_opted_in,
                ...response.data.topic[topic.id]
              } as PathTopic);
              ORM.run();
              deferred.resolve(response);
            })
            .catch((e: any) => {
              log.issue(`Unable to update your preference for ${topic.name}`);
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/toggle_topic_opt_in_command.ts